type ChapterRevisionState = {
  contentLocal: number
  contentAcked: number
  titleLocal: number
  titleAcked: number
}

const revisionsByChapter = new Map<string, ChapterRevisionState>()

function revisionKey(projectId: string, chapterId: string): string {
  return `${projectId}:${chapterId}`
}

function getState(projectId: string, chapterId: string): ChapterRevisionState {
  const key = revisionKey(projectId, chapterId)
  let state = revisionsByChapter.get(key)
  if (!state) {
    state = { contentLocal: 0, contentAcked: 0, titleLocal: 0, titleAcked: 0 }
    revisionsByChapter.set(key, state)
  }
  return state
}

export function bumpContentLocalRevision(projectId: string, chapterId: string): void {
  const state = getState(projectId, chapterId)
  state.contentLocal += 1
}

export function bumpTitleLocalRevision(projectId: string, chapterId: string): void {
  const state = getState(projectId, chapterId)
  state.titleLocal += 1
}

export function ackContentRevision(projectId: string, chapterId: string): void {
  const state = getState(projectId, chapterId)
  state.contentAcked = state.contentLocal
}

export function ackTitleRevision(projectId: string, chapterId: string): void {
  const state = getState(projectId, chapterId)
  state.titleAcked = state.titleLocal
}

export function forceAckAllRevisions(projectId: string, chapterId: string): void {
  const state = getState(projectId, chapterId)
  state.contentAcked = state.contentLocal
  state.titleAcked = state.titleLocal
}

export function hasUnconfirmedContentChanges(projectId: string, chapterId: string): boolean {
  const state = getState(projectId, chapterId)
  return state.contentLocal > state.contentAcked
}

export function hasUnconfirmedTitleChanges(projectId: string, chapterId: string): boolean {
  const state = getState(projectId, chapterId)
  return state.titleLocal > state.titleAcked
}

export function hasUnconfirmedEditorChanges(projectId: string, chapterId: string): boolean {
  return hasUnconfirmedContentChanges(projectId, chapterId)
    || hasUnconfirmedTitleChanges(projectId, chapterId)
}

export function clearChapterRevisions(projectId: string, chapterId: string): void {
  revisionsByChapter.delete(revisionKey(projectId, chapterId))
}

export function resetChapterRevisionsForTests(): void {
  revisionsByChapter.clear()
}
